/* eslint-disable import/order */
import { rovoOpsSettingsEntryPoint } from '@jira/spa-apps__project-settings-service-desk-rovo-ops/src/rovoOpsSettingsEntryPoint.entrypoint.tsx';
import { projectSettingsServicedeskRovoOpsRoute } from '@jira/router-routes__project-settings-rovo-ops-settings-routes/src/projectSettingsServicedeskRovoOpsRoute.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const rovoOpsPageEntryPoint = createPageEntryPoint({
	main: rovoOpsSettingsEntryPoint,
});

export const projectSettingsServicedeskRovoOpsRouteEntry: Route = createEntry(
	projectSettingsServicedeskRovoOpsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-rovo-ops-settings',
		layout: serviceProjectLayout,

		navigation: {
			menuId: 'PROJECTS',
			sidebarId: 'PROJECT_SETTINGS',
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		perfMetricKey: 'jsm-rovo-ops-settings',

		entryPoint: () => rovoOpsPageEntryPoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
